// extracted by mini-css-extract-plugin
export var container = "_8m-0";
export var error = "_8m-9";
export var label = "_8m-5";
export var light = "_8m-6";
export var md = "_8m-3";
export var sm = "_8m-2";
export var thin = "_8m-8";
export var thinBold = "_8m-7";
export var vertical = "_8m-4";
export var xs = "_8m-1";